<template>
  <div>
    <TicketForm :editMode="false"  />
  </div>
</template>

<script>
import TicketForm from '@/components/ModuleBasedComponents/support/TicketForm.vue';

export default {
    components: { TicketForm }
}
</script>

